'use strict';
module.exports = require('./lib/index');



/*****************
 ** WEBPACK FOOTER
 ** ./~/shortid/index.js
 ** module id = 525
 ** module chunks = 0
 **/